export default "__VITE_ASSET__3059adbc__"